import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { connectDynamic } from 'go/components/dynamic/dynamicComponent';
import { ContentDispatch } from 'framework';
import REST from 'go/requests/rest';
import DATA_FILTERS from 'go/components/common/dataFilters';

export const ProcessVarListener = ({
    data,
    contents,
    workflowTask,
    variablesToWatch,
    pollTime = 5000,
    callback,
    saveEntitySessionData,
    ...restProps
}) => {

    const variableValues = _.map(variablesToWatch, v => _.get(workflowTask, `processVariables.${v.variable}`))
    const [isPolling, setIsPolling] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    
    const fetchWorkflowTask = () => {
        setIsFetching(true);
        const taskId = _.get(workflowTask, 'task.id');
        REST.workflow.getWorkflowTask({ taskId })
            .then(REST.handler.handleResponse)
            .then(async res => {
                saveEntitySessionData('context.workflowTask', { ...res, loading: false })
                setIsFetching(false);
            })
            .catch(async () => {
                setIsFetching(false);
            })
    }

    useEffect(() => {
        let timer;
        if (isPolling && !isFetching){
            timer = setTimeout(fetchWorkflowTask, pollTime);
        }
        return () => clearTimeout(timer);
    }, [isPolling, isFetching]);

    useEffect(() => {
        if (workflowTask && !workflowTask.loading && variablesToWatch){
            let waitingForTarget = false;
            _.forEach(variablesToWatch, variableDetails => {
                const variableValue = _.get(workflowTask, `processVariables.${variableDetails.variable}`);
                const targetValue = _.get(variableDetails, 'targetValue');

                if (variableValue && !_.isEqual(variableValue, targetValue)){
                    waitingForTarget = true;
                }
            })
            if (!isPolling && waitingForTarget){
                setIsPolling(true);
            } else if (!waitingForTarget && isPolling){
                if (callback){
                    DATA_FILTERS[callback]({ saveEntitySessionData, ...restProps });
                }
                setIsPolling(false);
            }
        }
    }, [workflowTask, variablesToWatch, ...variableValues])
    
    return (
        <>
            {_.map(contents, (entry, index) => {
                return <ContentDispatch config={entry} key={entry.title} />;
            })}
        </>
    );
};

export default connectDynamic(ProcessVarListener);